var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "lang",
    class: _vm.isMobile && 'wap'
  }, [_c('div', {
    staticClass: "lang-main"
  }, [_c('div', {
    staticClass: "lang__label",
    on: {
      "click": function ($event) {
        $event.stopPropagation();
        return _vm.onLangShow.apply(null, arguments);
      }
    }
  }, [_c('em', [_c('svg-icon', {
    attrs: {
      "name": "icon-lang"
    }
  })], 1), _c('span', [_vm._v(_vm._s(_vm.selectLangValue))]), _c('svg-icon', {
    attrs: {
      "name": "icon-arrow"
    }
  })], 1), _c('transition', [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.popLangShow,
      expression: "popLangShow"
    }],
    staticClass: "pop-lang"
  }, _vm._l(_vm.langList, function (item, index) {
    return _c('div', {
      key: index,
      staticClass: "lang-item",
      class: _vm.selectLang == item.label && 'active',
      on: {
        "click": function ($event) {
          return _vm.onSelect(item);
        }
      }
    }, [_c('span', [_vm._v(_vm._s(item.label))])]);
  }), 0)])], 1)]);
};
var staticRenderFns = [];
export { render, staticRenderFns };